import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Company, Pagination, User } from '../models';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService extends BaseApiService<Company> {
  get cacheKey(): StorageKey {
    return StorageKey.classificationServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/companies`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    const user: User = this.storageService.get(StorageKey.currentUser);
    if (operation === 'list' && user?.adminUser || operation === 'list' && user?.adminManagerUser) {
      return `${environment.omniaCoreApiUrl}/v1/company`;
    }
    return url;
  }

  list(params: { [params: string]: string }): Promise<Pagination<Company>> {
    return super.list(this.removeContractId(params));
  }

  protected unparse(obj) {
    return Company.unparse(obj);
  }

  protected parse(obj) {
    return Company.parse(obj);
  }

}
